<template>
  <div class="dragable-block">
    <draggable
      class="list-group"
      :data-index="index"
      :data-type="'allocated'"
      :data-amId="amId"
      :style="'height:' + totalDays * 40 + 'px;'"
      :list="item"
      group="amSlot"
      :move="checkMove"
      @end="onDragDropEnd"
    >
      <div
        class="custom-list-item"
        v-for="(obj, listIndex) in item"
        :key="listIndex"
      >
        <div v-if="isAllocateVisits" class="custom-position">
          <v-icon
            @click="
              deleteAllocatedFrachisee(obj.amFranchiseeMapID, index, listIndex)
            "
            small
            >mdi-delete</v-icon
          >
        </div>
        <div
          :class="getColor(obj.priority)"
          class="am-text pa-2"
          style="border-bottom: solid 1px #000 !important"
          v-for="i in obj.visits"
          :key="replaceSpaceWithUnderscore(obj.companyName) + '_' + i"
        >
          {{ replaceSpaceWithUnderscore(obj.companyName) + '_' + i }}
        </div>
      </div>
    </draggable>
  </div>
</template>
<script>
import Utils from '@/utils'
import draggable from 'vuedraggable'
export default {
  name: 'DragAndDrop',
  components: {
    draggable
  },
  props: {
    item: {
      type: Array,
      default: () => {}
    },
    totalDays: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    amId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      toIndex: '',
      fromIndex: '',
      fromElementIndex: '',
      futureIndex: '',
      swapFranchise: {},
      toAmId: ''
    }
  },
  computed: {
    isAllocateVisits: function () {
      return this.checkModuleAccess('allocationAccess')
    }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    checkMove: function (evt) {
      // console.log(evt)
      if (this.isAllocateVisits) {
        if (
          evt.from.dataset.type === evt.to.dataset.type &&
          evt.from.dataset.index !== evt.to.dataset.index
        ) {
          this.swapFranchise = {}
          this.toIndex = evt.to.dataset.index
          this.toAmId = evt.to.dataset.amid
          this.fromIndex = evt.from.dataset.index
          this.futureIndex = evt.draggedContext.futureIndex
          this.fromElementIndex = evt.draggedContext.index
          this.swapFranchise = evt.draggedContext.element
          return true
        }
      }
      return false
    },
    onDragDropEnd: function (evt) {
      if (!this.isAllocateVisits) {
        return this.errMsg(
          'You are not authorize to relocate center between AMS'
        )
      }
      if (evt.from.dataset.index !== evt.to.dataset.index) {
        this.$emit('swapAllocatedFranchisee', {
          toIndex: this.toIndex,
          futureIndex: this.futureIndex,
          fromIndex: this.fromIndex,
          fromElementIndex: this.fromElementIndex,
          amId: this.toAmId,
          franchiseObj: this.swapFranchise
        })
      }
    },
    deleteAllocatedFrachisee: async function (
      franchiseeMapId,
      parentIndex,
      ChildIndex
    ) {
      this.$emit('deleteAllocatedFranchisee', {
        parentIndex: parentIndex,
        childIndex: ChildIndex,
        franchiseeMapId: franchiseeMapId
      })
    },
    replaceSpaceWithUnderscore: function (str) {
      return str.replaceAll(' ', '_')
    },
    getColor: function (priority) {
      if (priority === 1 || priority === 'H') {
        return 'deep-orange lighten-3'
      } else if (priority === 2 || priority === 'M') {
        return 'orange lighten-3'
      } else {
        return 'green lighten-2'
      }
    },
    errMsg: function (msg) {
      return this.$dialog.notify.info(msg, {
        position: 'top-right',
        color: 'error',
        timeout: 4000
      })
    }
  }
}
</script>
